const state =  () => {
  return {
    permissions: {}
  }
};

const getters = {
  permissions: state => {
    return state.permissions
  },
};

const actions = {
  setPermissionWebsite({ commit }, {websitePermissions}) {
    let permissions = {
      ...websitePermissions
    };
    commit('SET_PERMISSION_WEB_SITE', permissions);
  }
}

const mutations = {
  SET_PERMISSION_WEB_SITE(state, data ) {    
    state.permissions = data
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};